// Lib
import React from 'react';
import { Toolbar, IconButton, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';

// Components
import mainLogo from '../../../../assets/img/mainLogo.png';
import HeaderLinks from '../HeaderLinks';

const PAGES_WITH_SEARCH = [
  '/materials',
  '/address-book',
  '/order-history',
  '/order-history/recurring',
  '/support/FAQ',
  '/cart/shipping-address',
  '/kits',
];

const HeaderToolbar = ({
  classes,
  cx,
  logoPath,
  isDesktopMode,
  isAuthPage,
  onlyLogoLink,
  HEADER_LINKS,
  isTabletMode,
  onCloseSideMenu,
  pathname,
  totalCountInCart,
  onLogout,
  isActiveSearch,
  isMobileMode,
  toggleSideMenu,
  onToggleSearchInput,
}) => (
  <Toolbar className={classes.toolbar}>
    <Link className={classes.mainLogo} id="logo-link" to={logoPath}>
      <img
        src={mainLogo}
        alt="GMOP logo"
        className={classes.logo}
        data-testid="header-logo"
      />
    </Link>
    {isDesktopMode && !isAuthPage && !onlyLogoLink && (
      <>
        <HeaderLinks
          HEADER_LINKS={HEADER_LINKS}
          classes={classes}
          cx={cx}
          isDesktopMode={isDesktopMode}
          isTabletMode={isTabletMode}
          onCloseSideMenu={onCloseSideMenu}
          pathname={pathname}
          totalCountInCart={totalCountInCart}
        />
        <Button
          id="logout-btn"
          onClick={onLogout}
          className={classes.logoutButton}>
          Log Out
        </Button>
      </>
    )}
    {!isActiveSearch && (
      <Box display="flex" gap={3}>
        {isMobileMode && PAGES_WITH_SEARCH.includes(pathname) && (
          <IconButton
            id="search-button"
            edge="start"
            aria-label="search"
            onClick={onToggleSearchInput}>
            <SearchIcon />
          </IconButton>
        )}
        {!isDesktopMode && !isAuthPage && !onlyLogoLink && (
          <IconButton
            className={classes.menuButton}
            edge="start"
            aria-label="menu"
            onClick={toggleSideMenu(true)}>
            <MenuIcon />
          </IconButton>
        )}
      </Box>
    )}
  </Toolbar>
);

export default HeaderToolbar;
